import React from 'react';
import get from 'lodash/get';
import pick from 'lodash/pick';
import { enhance } from '../../../lib/dynamicStore';
import initialActions, {
  addItemToCart,
  updateCart,
  removeCart,
  removeCartItem,
  requestQuote,
  downloadCSVSuccess,
  showOrderNotAvailable,
  showBlockedAccountModal,
  validateQuoteCode,
  requestQuoteClick,
  shareCartSubmit,
  shareCartAnalytics,
  shareCartClear,
} from './ShoppingCart.actions';
import {
  getOrderSummaryData,
  getpromoCodeDetails,
  resetCouponError,
  loadUserEmail,
  userAuthentication,
  productRecommendationTitleClick,
  setSwitchAccount,
  createSetupIntentId,
} from '../../../global/actions';
import saga from './ShoppingCart.saga';
import reducer from './ShoppingCart.reducer';

import ShoppingCartComponent from '../../../components/templates/ShoppingCart';

const ShoppingCart = props => (
  <ShoppingCartComponent
    {...pick(
      props,
      'shoppingCartData',
      'cartData',
      'labels',
      'config',
      'countryData',
      'soldTo',
      'dummySoldTo',
      'userState',
      'isAPILoading',
      'addToCart',
      'updateCartQuantity',
      'removeCart',
      'removeCartItem',
      'location',
      'onRequestAQuote',
      'addPromoCode',
      'getpromoCodeDetails',
      'promoCodeDetails',
      'countryStatus',
      'downloadCSVSuccess',
      'showOrderNotAvailableView',
      'approvalStatus',
      'showBlockedAccountModal',
      'userDetails',
      'countryConfig',
      'validateQuote',
      'requestQuoteClick',
      'resetCouponError',
      'loadUserEmail',
      'shareCartSubmit',
      'shareCartData',
      'shareCartAnalytics',
      'shareCartClear',
      'shippingInfo',
      'userAuthentication',
      'shortTermTokeExpiredData',
      'productRecommendationData',
      'productRecommendationAddToCart',
      'productRecommendationTitleClick',
      'createSetupIntentId',
      'setSwitchAccount'
    )}
  />
);

export const mapStateToProps = state => ({
  shoppingCartData: get(state, ['shoppingCart', 'shoppingCartData'], {}),
  cartData: get(state, ['global', 'globalData', 'cart'], {}),
  labels: get(state, ['global', 'globalData', 'labels'], {}),
  config: get(state, ['global', 'globalData', 'config'], {}),
  userState: get(state, ['global', 'globalData', 'userState']),
  promoCodeDetails: get(state, ['global', 'globalData', 'promoCodeDetails'], {}),
  isAPILoading: get(state, ['global', 'globalData', 'isAPILoading']),
  countryData: get(state, ['global', 'globalData', 'countryData', '0'], {}),
  userDetails: get(state, ['global', 'globalData', 'userDetails'], {}),
  soldTo: get(state, ['global', 'globalData', 'userDetails', 'soldTo'], []),
  dummySoldTo: get(state, ['global', 'globalData', 'userDetails', 'dummySoldto']),
  countryStatus: get(state, ['global', 'globalData', 'countryStatus'], ''),
  approvalStatus: get(state, ['global', 'globalData', 'userDetails', 'approvalStatus'], ''),
  countryConfig: get(state, ['global', 'globalData', 'countryConfig'], ''),
  shareCartData: get(state, ['shoppingCart', 'shoppingCartData', 'shareCart'], {}),
  shippingInfo: get(state, ['global', 'globalData', 'shippingInfo'], []),
  shortTermTokeExpiredData: get(state, ['global', 'globalData', 'shortTermToken'], {}),
  productRecommendationData: get(state, ['global', 'globalData', 'productRecommendationData'], []),
});

export const mapDispatchToProps = dispatch => ({
  addToCart: (skuId, qty) => dispatch(addItemToCart(skuId, qty)),
  productRecommendationAddToCart: (skuId, qty, isProductRecommendation) =>
    dispatch(addItemToCart(skuId, qty, false, isProductRecommendation)),
  updateCartQuantity: data => dispatch(updateCart(data)),
  removeCart: () => dispatch(removeCart()),
  removeCartItem: data => dispatch(removeCartItem(data)),
  onRequestAQuote: data => dispatch(requestQuote(data)),
  addPromoCode: data => dispatch(getOrderSummaryData(data)),
  getpromoCodeDetails: data => dispatch(getpromoCodeDetails(data)),
  downloadCSVSuccess: () => dispatch(downloadCSVSuccess()),
  showOrderNotAvailableView: () => dispatch(showOrderNotAvailable()),
  showBlockedAccountModal: () => dispatch(showBlockedAccountModal()),
  validateQuote: data => dispatch(validateQuoteCode(data)),
  requestQuoteClick: () => dispatch(requestQuoteClick()),
  resetCouponError: () => dispatch(resetCouponError()),
  loadUserEmail: () => dispatch(loadUserEmail()),
  shareCartSubmit: data => dispatch(shareCartSubmit(data)),
  shareCartAnalytics: () => dispatch(shareCartAnalytics()),
  shareCartClear: data => dispatch(shareCartClear(data)),
  userAuthentication: data => dispatch(userAuthentication(data)),
  productRecommendationTitleClick: data => dispatch(productRecommendationTitleClick(data)),
  createSetupIntentId: data => dispatch(createSetupIntentId(data)),
  setSwitchAccount: (soldTo, onSuccess) => dispatch(setSwitchAccount(soldTo, onSuccess)),
});

export default enhance(ShoppingCart, {
  mapStateToProps,
  mapDispatchToProps,
  saga,
  reducer,
  key: 'shoppingCart',
  initialActions,
  fireActionsOnEachMount: true,
});
